// src/utilities/date-time/timezone.ts
// vue
import { ref, onMounted, Ref } from 'vue'

// vendors
import axios from 'axios'

// utilities
import { capitalize } from '@/utilities'

/**
 * Interface TimeZone.
 */
interface TimeZone {
  countryCode: string
  countryName: string
  gmtOffset: number
  timestamp: number
  zoneName: string
}

/**
 * Returns a list of all time zones.
 * @returns {TimeZone[] | undefined}
 */
export function timeZones(): Ref<TimeZone[] | undefined> {
  const timezones = ref<TimeZone[] | undefined>()

  onMounted(() => {
    axios
      .get('https://api.timezonedb.com/v2.1/list-time-zone?key=PJ3WFAM872HM&format=json', {
        withCredentials: false
      })
      .then(res => {
        if (res.data.status === 'OK') {
          timezones.value = res.data.zones
        } else {
          throw new Error(res.data.message)
        }
      })
      .catch(err => {
        throw new Error(err)
      })
  })

  // return the reactive ref
  return timezones
}

/**
 * Timezone Formatter
 * Formats a timezone (e.g. "America/New_York") into a nice-looking string (e.g. "America - New York").
 * Underscores are replaced by spaces, and each word is capitalized.
 * @param timezone string
 */
export function formatTimezone(timezone: string): string | null {
  if (!timezone) return null

  const formattedTimezone = timezone
    .split('/')
    .map(part =>
      part
        .split('_')
        .map(word => capitalize(word))
        .join(' ')
    )
    .join(' - ')

  return formattedTimezone
}
